<template>
  <div id="xfStarDirection" class="animated fadeInRight" style="animation-duration: 3s">
    <div id="xfStar" style="padding-top: 20px;">
      <p style="color: snow">消防星三角操作说明</p>
      <div id="tv_Show">
        正在更新
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'xfStarDirection',
  data () {
    return {
      
    }
  }
}
</script>

<style scoped>
  #tv_Show{
    width: 600px;
    height:400px;
    position:relative;left:20%;
  }
  @media (min-width: 340px) {
    #tv_Show{
      width: 270px;
      height:180px;
      position:relative;left:5%;
    }
  }
  @media (min-width: 768px) {
    #tv_Show{
      width: 570px;
      height:380px;
      position:relative;left:5%;
    }
  }
  @media (min-width: 992px) {
    #tv_Show{
      width: 600px;
      height:400px;
      position:relative;left:22%;
    }
  }
  @media (min-width: 1360px) {
    #tv_Show{
      width: 600px;
      height:400px;
      position:relative;left:20%;
    }
  }
  @media (min-width: 1920px) {
    #tv_Show{
      width: 1200px;
      height:800px;
      position:relative;left:35%;
    }
  }
</style>
